import type { Location } from 'history';
import { matchPath } from 'react-router-dom';

import { getRoute, routeNames } from '../shared/helpers/routes';
import type { Vendor } from '../types';
import { config } from '../config';

const getFromDocumentaryPath = ({ location }: { location: Location }) => {
  if (config.provider !== 'vgtv') {
    return undefined;
  }

  const match = matchPath(location.pathname, getRoute(routeNames.documentary));

  if (!match) {
    return undefined;
  }

  const searchParams = new URLSearchParams(location.search);

  return parseInt(searchParams.get('id') || '', 10);
};

const getFromEpisodePath = ({ location }: { location: Location }) => {
  if (config.provider !== 'vgtv') {
    return undefined;
  }

  const match = matchPath(location.pathname, getRoute(routeNames.episode));

  if (!match) {
    return undefined;
  }

  const searchParams = new URLSearchParams(location.search);

  return parseInt(searchParams.get('id') || '', 10);
};

const getFromNewsPath = ({ location }: { location: Location }) => {
  if (config.provider !== 'vgtv') {
    return undefined;
  }

  const match = matchPath(location.pathname, getRoute(routeNames.news));

  if (!match) {
    return undefined;
  }

  const searchParams = new URLSearchParams(location.search);

  return parseInt(searchParams.get('id') || '', 10);
};

const getFromAssetPath = ({
  location,
  vendor,
}: {
  location: Location;
  vendor?: Vendor;
}) => {
  const match = matchPath<{ assetId?: string }>(
    location.pathname,
    getRoute(routeNames.asset, { vendor })
  );

  if (!match?.params.assetId) {
    return undefined;
  }

  return parseInt(match.params.assetId);
};

export const getAssetIdFromLocation = (params: {
  location: Location;
  vendor?: Vendor;
}) => {
  return (
    getFromAssetPath(params) ||
    getFromDocumentaryPath(params) ||
    getFromEpisodePath(params) ||
    getFromNewsPath(params)
  );
};
